import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';

import type { ConnectionPlatformDisplay } from '../types.js';
import { ReconnectButton } from './ReconnectButton.js';
import { RemoveConnectionButton } from './RemoveConnectionButton.js';

interface Props {
  platform: ConnectionPlatformDisplay;
  isAllowedRemove: boolean;
  onRemove: () => void;
  onReconnect: () => void;
  isButtonsHidden: boolean;
  /** Datadog action name for the reconnect button, forwarded unchanged; pass a per-platform literal. */
  reconnectActionName: string;
}

export const ManageConnectionHeader = ({
  platform,
  isAllowedRemove,
  onRemove,
  onReconnect,
  isButtonsHidden,
  reconnectActionName,
}: Props) => {
  const { t } = useTranslation('@mint-lib/connections-ui');

  return (
    <div className="mb-4 flex justify-between">
      <h4
        className={`${typographyVariants({ variant: 'h4' })} self-center`}
        data-dd-action-name="Manage connection panel"
      >
        {t('Manage {{platformName}} connection', {
          platformName: platform?.label,
        })}
      </h4>
      {!isButtonsHidden && (
        <div className="flex items-center">
          <ReconnectButton
            platform={platform}
            onReconnect={onReconnect}
            data-dd-action-name={reconnectActionName}
          />
          <RemoveConnectionButton
            isAllowedRemove={isAllowedRemove}
            onRemove={onRemove}
          />
        </div>
      )}
    </div>
  );
};
